import { render, staticRenderFns } from "./accountShare.vue?vue&type=template&id=392e4b0c&scoped=true"
import script from "./accountShare.vue?vue&type=script&lang=js"
export * from "./accountShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e4b0c",
  null
  
)

export default component.exports